import { Component, OnInit, HostListener, ViewContainerRef, Inject, PLATFORM_ID, ViewChild, TemplateRef } from '@angular/core';
import { ListsService } from '../../lists.service';
import { Lightbox } from '@ngx-gallery/lightbox';
import { isPlatformBrowser } from '@angular/common';
import { localStorageName } from '../../names';
import { FindSalonService } from 'src/app/find-salon.service';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  showCookie;
  toggleMenu = false;
  diagnoza_res;
  hackMenu = false;

  isBrowser;

  @ViewChild(TemplateRef, { static: false }) tpl: TemplateRef<any>;

  @HostListener('window:click', ['$event']) onClick(event) {
    if (event.target.classList.contains('cdk-global-overlay-wrapper')) {
      this._lightbox.close();
    }
  }

  isSticky: boolean = false;

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.isSticky = window.pageYOffset >= 250;
  }

  top() {
    window.scroll(0, 0);
  }

  constructor(
    public _lists: ListsService,
    private _lightbox: Lightbox,
    public findSalon: FindSalonService,
    @Inject(PLATFORM_ID) private platformId
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  closeCookie() {
    if (this.isBrowser) {
      localStorage.setItem(localStorageName.cookies, '1');
    }
    this.showCookie = 1;
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.diagnoza_res = localStorage.getItem(localStorageName.diagnozaOdp);
      this.showCookie = localStorage.getItem(localStorageName.cookies);
    }

  }

  scrollToTop() {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 100); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }
}
